import "./design-with-ai-cta.scss";
import { track } from "jiffy-analytics";

const $getContainer = () => document.querySelector(".js-design-with-ai-cta");

class DesignWithAiCta {
  constructor($container) {
    this.$container = $container;
    this.handleClick = this.handleClick.bind(this);
  }

  get $designWithAiLink() {
    return this.$container.querySelector(".js-design-with-ai-cta-button");
  }

  init() {
    if (this.$designWithAiLink) {
      this.$designWithAiLink.addEventListener("click", this.handleClick);
    }
  }

  disableLink() {
    if (this.$designWithAiLink) {
      this.$designWithAiLink.setAttribute("aria-disabled", "true");
      this.$designWithAiLink.classList.add("design-with-ai-cta__button--disabled");
    }
  }

  handleClick(e) {
    if (this.$designWithAiLink?.getAttribute("aria-disabled") === "true") {
      e.preventDefault();
      return;
    }

    this.disableLink();

    track("ai_studio_cta_clicked", {
      source: "header_design_with_ai_cta",
      timestamp: new Date().toISOString()
    });
  }
}

const initComponent = () => {
  const $container = $getContainer();
  if (!$container) return;

  new DesignWithAiCta($container).init();
};

document.addEventListener("DOMContentLoaded", initComponent);
